import { render } from "./DashboardSubKomunitasView.vue?vue&type=template&id=cf8b824e"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__